import axios from 'axios';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import {
  setCouponList,
  setCouponCreate,
} from '../../../Redux/cscoupons/couponsSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

export const CouponCreate = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/create-coupon`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setCouponCreate(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
    }
  }
};

export const fetchCouponList = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/list-coupons`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    dispatch(setCouponList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

export const fetchCouponDetails = async ({ params }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/get-coupon-details`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
    }
  }
};

export const downloadCouponVoucher = async ({ params }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiUrl}v1/orders/download-coupon`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      window.location.replace('/logout');
    }
  }
};
